import React from "react"
import styled from "@emotion/styled"
import tw from "twin.macro"

import { withAccountLogout } from "./withAccountLogout"
import { StyledButton } from "../../Styled/Button"

const Button = styled(StyledButton)`
  ${tw`uppercase`}
  & {
    width: max-content;
  }
`

export const AccountLogout = withAccountLogout(
  ({ handleLogout, additionalLogoutButton }): JSX.Element => (
    <Button className={`secondary_button`} layout={`secondary`} colour={`transparent`} onClick={() => handleLogout()} textsize={`md`}>
      {additionalLogoutButton}
    </Button>
  )
)
